import {RouteConfig} from "vue-router";
const AnalyticsList = () => import('../views/analytics/AnalyticsList.vue');
const AnalyticsGames = () => import('../views/analytics/AnalyticsGames.vue');

let analytics: RouteConfig[] = [
    {
        name: 'analytics',
        path: '/analytics',
        component: AnalyticsList,
        redirect: {name: 'analytics-games'},
        children: [
            {
                name: 'analytics-games',
                path: '/analytics/games',
                component: AnalyticsGames,
            }
        ]
    },
];

export default analytics;
